import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { KmDataType } from "./KhmListPage";

const initailData: KmDataType = {
  idx: -1,
  site_name: "",
  title_km: "",
  url: "",
  text_km: "",
  issue_date: "",
  writer_km: "",
  copyrighter_km: "",
  orgext: "",
  data_type: "",
  topic_km: "",
  keyword_km: "",
  keyword2_km: "",
  worker:"",
  work_date:"",
  work_yn:"",
  prc_date:"",
  prc_yn:"",

  title_ko: "",
  text_ko: "",
  keyword_ko: "",

  title_en: "",
  text_en: "",
  keyword_en: "",
};

export interface DetailTrans {
  idx: number;
  crw_idx: number;
  title_ko: string;
  text_ko: string;
  title_en: string;
  text_en: string;
  ins_date: string;
}

const initailDetailData: DetailTrans = {
  idx: -1,
  crw_idx: -1,
  title_ko: "",
  text_ko: "",
  title_en: "",
  text_en: "",
  ins_date: "",

};


const KhmDetailDialog = (props: any) => {
  // console.log("props", props);

  const [data, setData] = useState<any>(initailData);

  const [detail, setDetail] = useState<DetailTrans>(initailDetailData);

  const [state, setState] = useState("ko")

  const [check_1, setCheck_1] = useState(false);
  const [check_2, setCheck_2] = useState(false);
  const [check_3, setCheck_3] = useState(false);
  const [check_4, setCheck_4] = useState(false);
  const [check_5, setCheck_5] = useState(false);
  const [check_6, setCheck_6] = useState(false);
  const [check_7, setCheck_7] = useState(false);
  const [check_8, setCheck_8] = useState(false);
  const [check_9, setCheck_9] = useState(false);
  const [check_10, setCheck_10] = useState(false);

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const checkList = (check_num:number) => {
    if(check_num == 1){setCheck_1(!check_1)}
    if(check_num == 2){setCheck_2(!check_2)}
    if(check_num == 3){setCheck_3(!check_3)}
    if(check_num == 4){setCheck_4(!check_4)}
    if(check_num == 5){setCheck_5(!check_5)}
    if(check_num == 6){setCheck_6(!check_6)}
    if(check_num == 7){setCheck_7(!check_7)}
    if(check_num == 8){setCheck_8(!check_8)}
    if(check_num == 9){setCheck_9(!check_9)}
    if(check_num == 10){setCheck_10(!check_10)}
    // setAgree_2(agree_2 => !agree_2)
  }

  // let manager_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const getDetail = async (idx: number) => {
    var result = await api.get("/km-detail",{params:{idx:idx}});
    console.log('getDetail', result.data.datas[0]);
    setDetail(result.data.datas[0])
  };

  const saveKmData = async (prc_yn:string) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("prc_yn", prc_yn);

    formData.append("datas", JSON.stringify(data));

    let check_list = ""
    if(check_1){check_list+="1"}
    if(check_2){check_list+="2"}
    if(check_3){check_list+="3"}
    if(check_4){check_list+="4"}
    if(check_5){check_list+="5"}
    if(check_6){check_list+="6"}
    if(check_7){check_list+="7"}
    if(check_8){check_list+="8"}
    if(check_9){check_list+="9"}
    if(check_10){check_list+="10"}

    formData.append("checklist", check_list);

    await api.post("/km-prc-update",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  useEffect(() => {
    getAuths();
    setData(initailData);
    if(props.rowDetail != undefined){
      getDetail(props.rowDetail.idx)
    }
  }, [props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"20px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      {data ? <>
        <Box display="flex">
        <Box>
          <Paper sx={{padding:"8px", margin:"4px 16px 16px 16px", border:"3px solid #3e36a5", background: "linear-gradient(to right, #d5f0da 25%, #a3e4ed 75%)"}}>
              <Box sx={{width:"800px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                  {state === "km" ? 
                    <Box sx={{marginLeft:"4px"}}>
                      
                      
                      <Box sx={{display:"flex", justifyContent: "center"}}>
                        <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} />
                        <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>Kiswahili</Box>
                        <Button variant="contained" color="secondary"  size="small" sx={{marginLeft:"16px", fontWeight:700}} onClick={()=> setState("ko")}>변경(한국어)</Button>
                      </Box>

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                      <Box><textarea value={data.title_km} onChange={(e) => {setData({ ...data, title_km: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                      <Box><textarea value={data.text_km} onChange={(e) => {setData({ ...data, text_km: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"400px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                    </Box>

                    :
                    <Box sx={{marginLeft:"4px"}}>
                      
                      
                      <Box sx={{display:"flex", justifyContent: "center"}}>
                        <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} />
                        <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>한국어</Box>
                        <Button variant="contained" color="secondary" size="small" sx={{marginLeft:"16px", fontWeight:700}} onClick={()=> setState("km")}>변경(크메르어)</Button>
                      </Box>

                      {/* <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={data.keyword_sw} onChange={(e) => {setData({ ...data, keyword_sw: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"22px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box> */}
                      {detail && 
                      <>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                      <Box><textarea value={detail.title_ko} onChange={(e) => {setDetail({ ...detail, title_ko: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                      <Box><textarea value={detail.text_ko} onChange={(e) => {setDetail({ ...detail, text_ko: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"400px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      </>
                      }
                    </Box>
                    }
                    </Box>
                  </Box>
              </Box>
          </Paper>
        </Box>

        <Box>
          <Paper sx={{padding:"20px", margin:"16px",position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
              <Box display="flex" sx={{marginLeft: "8px"}}>
                <Box sx={{width:"100%"}}>
                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>IDX</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{data.idx}</Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>작업워커</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>작업상태</Box>

                    <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        backgroundColor: (data.prc_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                    }}>
                      {(data.prc_yn === "Y" ? "작업완료" : "미작업")}
                    </Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업데이트시간</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{data.prc_date}</Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>사이트명</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="site_name" name="site_name" size="small"
                                value={data.site_name} onChange={(e) => {setData({ ...data, site_name: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "500px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>출처 - URL</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                                value={data.url} onChange={(e) => {setData({ ...data, url: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "500px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>
                  
                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>발행일자</Box>
                    <Box sx={{fontSize:"14px", width:"200px"}}>
                      <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small" type="date"
                                value={data.issue_date} onChange={(e) => {setData({ ...data, issue_date: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "200px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box sx={{border:"2px solid #a9a6c9"}}>
                      <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                        {/* <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /> */}
                        <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>크메르어(KM)</Box>
                      </Box>
                      <Box display="flex">
                      <Box m={1} display="flex" sx={{alignItems:"center"}}>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px", spellCheck:"false"}} id="writer_km" name="writer_km" size="small"
                                    value={data.writer_km} onChange={(e) => {setData({ ...data, writer_km: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px", fontFamily: "Khmer OS, serif"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작권소유자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px", spellCheck:"false"}} id="copyrighter_km" name="copyrighter_km" size="small"
                                    value={data.copyrighter_km} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px", fontFamily: "Khmer OS, serif"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <Box m={3} display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>키워드</Box>
                        <Box sx={{fontSize:"14px", width:"500px"}}>
                          <TextField sx={{fontSize:"8px"}} id="keyword_km" name="keyword_km" size="small"
                                    value={data.keyword_km} onChange={(e) => {setData({ ...data, keyword_km: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "500px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  {/* <Box mt={2} display="flex">
                    <Box sx={{border:"2px solid #a9a6c9"}}>
                      <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                        <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} />
                        <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>한국어(KO)</Box>
                      </Box>
                      <Box m={1} display="flex" sx={{alignItems:"center"}}>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                    value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작자소유자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                    value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>

                  </Box> */}

                  <Box display="flex">
                    <Box m={2} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>파일형태(원본)</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>
                        <Select id="orgext" value={data.orgext} onChange={(e) => {setData({ ...data, orgext: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          <MenuItem dense value={"01"}>HTML</MenuItem>
                          <MenuItem dense value={"02"}>PDF</MenuItem>
                          <MenuItem dense value={"03"}>IMAGE</MenuItem>
                        </Select>
                      </Box>
                    </Box>

                    <Box m={2} ml={2} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>자료유형(원본)</Box>
                      <Box sx={{fontSize:"14px", width:"186px"}}>
                      <Select id="data_type" value={data.data_type} onChange={(e) => {setData({ ...data, data_type: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"01"}>저서</MenuItem>
                        <MenuItem dense value={"02"}>논문</MenuItem>
                        <MenuItem dense value={"03"}>기사</MenuItem>
                        <MenuItem dense value={"04"}>문서</MenuItem>
                        <MenuItem dense value={"05"}>직접작성</MenuItem>
                        <MenuItem dense value={"06"}>기타</MenuItem>
                      </Select>
                      </Box>
                    </Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>주제분류</Box>
                    <Select id="topic_km" value={data.topic_km} onChange={(e) => {setData({ ...data, topic_km: e.target.value });}} sx={{color:"green",width:"440px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      <MenuItem dense value={"01"}>문화,예술,교육{" "}<b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(វប្បធម៌,សិល្បៈ,ការអប់រំ)</b></MenuItem>
                      <MenuItem dense value={"02"}>역사,지리,관광 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍)</b></MenuItem>
                      <MenuItem dense value={"03"}>스포츠,기타 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(កីឡា,ផ្សេងៗ)</b></MenuItem>
                      <MenuItem dense value={"04"}>사회,산업 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(សង្គម,ឧស្សាហកម្ម)</b></MenuItem>
                      <MenuItem dense value={"05"}>정치,경제 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(នយោបាយ,សេដ្ឋកិច្ច)</b></MenuItem>
                      <MenuItem dense value={"06"}>과학,의학 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ)</b></MenuItem>
                      <MenuItem dense value={"07"}>관습,예절 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ទំនៀមទម្លាប,ទម្លាប់)</b></MenuItem>
                      <MenuItem dense value={"08"}>일상생활,음식 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ជីវិតប្រចាំថ្ងៃ,អាហារ)</b></MenuItem>
                    </Select>
                  </Box>

                

                  <Box sx={{border:"2px solid #4539ca"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, margin:"4px", width:"102px"}}>체크리스트</Box>
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(1)} checked={check_1}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>1. 원시데이터와 환경정보(메타정보)의 내용이 불일치한가?</Box></Box>     
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(2)} checked={check_2}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>2. 민감한 이슈(정치), 이메일 연락처, 개인고유식별번호 등을 포함하고 있는가?</Box></Box>     
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(3)} checked={check_3}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>3. 무분별한 비난 또는 혐오적인 내용이 있는가?</Box></Box>
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(4)} checked={check_4}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>4. 선정적인 내용 또는 상업적 목적의 내용이 있는가?</Box></Box>
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(5)} checked={check_5}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>5. 오타나 문법 오류 등이 포함되어 있는가?</Box></Box>     
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(6)} checked={check_6}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>6. 저작권 침해의 가능성이 있는가?</Box></Box>      
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(7)} checked={check_7}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>7. 텍스트 내용에 대한 주제 분류가 틀리게 되었는가?</Box></Box> 
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(8)} checked={check_8}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>8. 텍스트 내용에 적합한 키워드 들이 잘못 지정되었는가?</Box></Box> 
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(9)} checked={check_9}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>9. 불필요한 기호나 띄어쓰기, 이모티콘 등이 존재하는가?</Box></Box> 
                    <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(10)} checked={check_10}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>10. 스와힐리어 외에, 주로 다른 언어가 포함되었는가?</Box></Box> 
                  </Box>

                  
                </Box>
              </Box>
          </Paper>
          
          <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                saveKmData('N');
              }}
            >
              부적합
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                saveKmData('Y');
              }}
            >
              적합
            </Button>
          </Box>
        </Box>
        

        
      </Box></> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default KhmDetailDialog;
